<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    :width="size"
    :height="size"
    viewBox="0 0 21 21"
  >
    <g>
      <g>
        <path
          :fill="color"
          d="M19.298 11.099c0 .29-.208.536-.494.584l-1.324.221a.647.647 0 0 0-.514.45c-.118.381-.28.77-.48 1.157a.647.647 0 0 0 .047.678l.78 1.096a.591.591 0 0 1-.064.763l-1.202 1.201a.58.58 0 0 1-.417.175.584.584 0 0 1-.345-.11l-1.09-.78a.647.647 0 0 0-.681-.047 7.072 7.072 0 0 1-1.16.48.647.647 0 0 0-.446.512l-.225 1.325a.591.591 0 0 1-.585.495H9.397a.591.591 0 0 1-.585-.494l-.22-1.324a.648.648 0 0 0-.446-.514 7.03 7.03 0 0 1-1.122-.461.65.65 0 0 0-.677.047l-1.11.79a.58.58 0 0 1-.756-.066l-1.205-1.203a.587.587 0 0 1-.064-.759l.776-1.078a.647.647 0 0 0 .046-.687 6.869 6.869 0 0 1-.486-1.153.649.649 0 0 0-.51-.444l-1.343-.23a.591.591 0 0 1-.494-.584V9.442c0-.291.208-.537.495-.585l1.308-.22a.647.647 0 0 0 .514-.453c.123-.403.282-.794.472-1.16a.648.648 0 0 0-.048-.677L3.154 5.24a.59.59 0 0 1 .063-.762l1.206-1.201.004-.005a.575.575 0 0 1 .414-.171c.126 0 .244.038.343.109l1.083.78a.646.646 0 0 0 .686.046c.37-.198.758-.361 1.153-.486a.649.649 0 0 0 .445-.511l.229-1.342a.591.591 0 0 1 .585-.495h1.697c.29 0 .537.208.585.495l.22 1.308a.647.647 0 0 0 .453.514c.405.124.81.29 1.202.495a.648.648 0 0 0 .679-.046l1.098-.783a.58.58 0 0 1 .756.066l1.204 1.204a.587.587 0 0 1 .063.76l-.78 1.092a.648.648 0 0 0-.047.68c.192.367.353.757.48 1.159.073.235.27.406.511.446l1.325.225c.287.048.491.29.487.577zm-.286-3.467l-1-.17a8.298 8.298 0 0 0-.3-.727l.588-.823c.512-.72.43-1.692-.194-2.31l-1.201-1.2a1.781 1.781 0 0 0-2.305-.194l-.827.589a8.24 8.24 0 0 0-.776-.32l-.166-.98A1.789 1.789 0 0 0 11.061 0H9.366c-.88 0-1.624.63-1.77 1.495l-.173 1.018c-.246.09-.488.192-.725.305l-.811-.584a1.776 1.776 0 0 0-1.045-.335c-.482 0-.932.187-1.268.528l-1.204 1.2a1.789 1.789 0 0 0-.194 2.309l.598.84c-.11.238-.21.482-.297.73l-.98.166A1.789 1.789 0 0 0 0 9.442v1.697c0 .88.63 1.624 1.495 1.77l1.018.173c.09.245.191.487.305.724l-.582.81c-.513.72-.43 1.692.193 2.31l1.202 1.2a1.781 1.781 0 0 0 2.304.195l.84-.599c.222.103.45.197.686.282l.166 1c.146.866.89 1.496 1.77 1.496h1.701c.88 0 1.624-.63 1.77-1.496l.169-1c.248-.089.49-.19.727-.3l.821.586c.304.22.666.335 1.045.335.477 0 .927-.187 1.267-.526l1.201-1.202a1.789 1.789 0 0 0 .194-2.309l-.59-.827c.115-.242.215-.485.302-.726l.999-.167a1.789 1.789 0 0 0 1.496-1.77V9.406a1.77 1.77 0 0 0-1.487-1.773z"
        />
      </g>
      <g>
        <path
          :fill="color"
          d="M10.25 13.035a2.788 2.788 0 0 1-2.785-2.785 2.788 2.788 0 0 1 2.785-2.785 2.788 2.788 0 0 1 2.784 2.785 2.788 2.788 0 0 1-2.784 2.785zm0-6.77a3.99 3.99 0 0 0-3.986 3.985 3.99 3.99 0 0 0 3.986 3.986 3.99 3.99 0 0 0 3.985-3.986 3.99 3.99 0 0 0-3.985-3.986z"
        />
      </g>
    </g>
  </svg>
</template>

<script>
export default {
  props: {
    color: {
      type: String,
      default: '#71767D',
    },
    size: {
      type: Number,
      default: 21,
    },
  },
};
</script>
